import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { AppProviders } from '@/app-root';
import '@/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

// Prerendered routes (`/`, `/about`, `/privacy`, `/terms`, `/support`) ship with
// their HTML already inside `#root`, so the first paint happens before this
// script runs. Mounting with `createRoot` replaces that markup with the live
// app; the fallback shell (`dist/shell.html`, served for `/reset` and unknown
// paths) starts empty. Either way, the client renders the same tree the
// prerender did — see `scripts/prerender.tsx`.
createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
